import React, { Component, useState, useEffect } from "react"
import CaseStudy from "../../molecules/CaseStudy"
import "./styles.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import SwiperCore, { Mousewheel, Scrollbar } from "swiper"
import "swiper/components/scrollbar/scrollbar.scss"
import SectionHeader from "../../molecules/SectionHeader"
import CTA from "../../atoms/CTA"
import "swiper/swiper.scss"
import { Link } from "gatsby"
import Img from "gatsby-image"
SwiperCore.use([Mousewheel, Scrollbar])

class CaseStudySlider extends Component {
  constructor(props) {
    super()
    this.state = {
      caseStudies: props.caseStudies,
      activeIndex: 0,
      csHeight: 0,
      height: 0,
      isTablet: false,
      onHoverIndex: null,
      viewportCenter: 0,
    }
    this.onImgLoad = this.onImgLoad.bind(this)
    this.onCSLoad = this.onCSLoad.bind(this)
    this.onImgMouseOver = this.onImgMouseOver.bind(this)
  }

  onImgLoad({ target: img }) {
    this.setState({
      height: img.offsetHeight,
    })
  }

  onImgMouseOver(i) {
    this.setState({
      activeHoverIndex: i,
    })
  }

  onCSLoad({ target: img }) {
    this.setState({
      height: img.offsetHeight,
    })
  }

  componentDidMount() {
    const height = this.divElement.clientHeight
    const csHeight = this.csElement.clientHeight
    this.setState({ height })
    this.setState({ csHeight })

    const headings = document.querySelectorAll(".caseStudy__image")

    this.setState({
      viewportCenter: window.innerHeight / 2,
    })

    let options = {
      threshold: window.innerHeight <= 976 ? 0.8 : 1,
    }

    const updateNav = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.setState({
            activeIndex: [...entry.target.parentElement.children].indexOf(
              entry.target
            ),
          })
        }
      })
    }
    let observer = new IntersectionObserver(updateNav, options)

    for (let x = 0; x < headings.length; x++) {
      observer.observe(headings[x])
    }

    if (document.body.clientWidth > 500) {
      this.setState({
        isTablet: true,
      })
    } else {
      this.setState({
        isTablet: false,
      })
    }
  }

  render() {
    return (
      <section
        ref={this.props.ref}
        className="section section--caseStudySlider"
      >
        <div className="wrapper">
          {this.props.isDesktop ? (
            <div className="caseStudies">
              <div className="left">
                {this.state.caseStudies.map((caseStudy, i) => {
                  return (
                    <CTA
                      to={caseStudy.button.link}
                      className="caseStudy__image"
                      key={i}
                    >
                      <img
                        onMouseEnter={() => this.onImgMouseOver(i)}
                        onMouseLeave={() => this.onImgMouseOver(null)}
                        onLoad={this.onImgLoad}
                        src={caseStudy.image?.childImageSharp?.fluid?.src}
                        alt={caseStudy.title.title}
                        ref={divElement => {
                          this.divElement = divElement
                        }}
                      />
                    </CTA>
                  )
                })}
              </div>
              <div
                style={{
                  top: `${this.state.height / 2 - 87}px `,
                  bottom: `${this.state.height / 2 - 87}px `,
                }}
                className="right"
              >
                {this.props.caseStudies.map((caseStudy, i) => {
                  return (
                    <div
                      onLoad={this.onCSLoad}
                      key={i}
                      style={{
                        top: `${this.state.viewportCenter - 87}px `,
                        bottom: `${this.state.viewportCenter - 87}px `,
                      }}
                      ref={csElement => {
                        this.csElement = csElement
                      }}
                      className={`${
                        this.state.activeIndex === i
                          ? "caseStudy active"
                          : "caseStudy"
                      } ${this.state.activeHoverIndex === i ? "hovered" : ""} `}
                    >
                      <CTA to={caseStudy.button.link}>
                        <SectionHeader
                          type="h3"
                          subtitle={caseStudy.title.subtitle}
                        >
                          {caseStudy.title.title}
                        </SectionHeader>
                        <span className="btn--bordered btn">
                          {caseStudy.button.title}
                        </span>
                      </CTA>
                    </div>
                  )
                })}
              </div>
            </div>
          ) : (
            <div className="caseStudies__mobile">
              <Swiper
                direction="horizontal"
                spaceBetween={24}
                slidesPerView={this.state.isTablet ? 2.2 : 1.2}
                centeredSlides={false}
              >
                {this.state.caseStudies.map((caseStudy, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <CaseStudy isEmpty={false} caseStudy={caseStudy} />
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          )}
        </div>
      </section>
    )
  }
}

export default CaseStudySlider
